import React from 'react';
import './Projects.css';
import { Link, useNavigate } from 'react-router-dom';


function Projects({ setProjects }) {
  const navigate = useNavigate();

  const handleClose = () => {
    navigate('/');
    setProjects(false);
  };
  return (
    <div className="postcard projects" style={{overflowX: 'hidden'}}>
      <div className="message absolute" style={{maxWidth: '100%'}}>
        <h1 style={{ marginTop: '-40px', height: '40px', textAlign: 'center'}}>Projects <Link className="social-button github" to="https://www.github.com/riyasachdeva04" target="_blank"><i className="fab fa-github"></i></Link></h1>
          <div className="card mx-4 my-4 py-4 col-sm-6 col-md-5">
            <img src="/images/deepfake.jpeg" className="card-img-top mt-2" alt="..." style={{'height': '170px', 'alignSelf': 'center'}}/>
            <div className="card-body">
              <h5 className="card-title" style={{'color': 'white', 'paddingLeft': '40%'}}>Deepword</h5>
              <p className="card-text" style={{'color': 'white'}}>
                Analyzing intent, vocabulary, posture, and gestures on YouTube using Selenium scraping to uncover potential deepfakes.
              </p>
              
            </div>
          </div>
          <div className="card mx-4 my-4 py-4 col-sm-6 col-md-5" >
            <img src="/images/skinbot.jpeg" className="card-img-top mt-2" alt="..." style={{'height': '170px', 'alignSelf': 'center'}}/>
            <div className="card-body">
              <h5 className="card-title" style={{'color': 'white', 'paddingLeft': '40%'}}>Skin bot</h5>
              <p className="card-text" style={{'color': 'white'}}>
                Delivering tailored skincare advice by utilizing advanced neural networks for precise intent recognition and response generation.
              </p>
              
            </div>
          </div>
          <div className="card mx-4 my-4 py-4 col-sm-6 col-md-5" >
            <img src="/images/sahyog.jpeg" className="card-img-top mt-2" alt="..." style={{'height': '170px', 'alignSelf': 'center'}}/>
            <div className="card-body">
              <h5 className="card-title" style={{'color': 'white', 'paddingLeft': '40%'}}>Sahyog</h5>
              <p className="card-text" style={{'color': 'white'}}>
                Seamlessly analyzing text, images, and speech in Indian languages, crafting a vibrant marketplace that resonates with Desi culture.
              </p>
              
            </div>
          </div>
          {/* <div className="card mx-4 my-4 py-4 col-sm-6 col-md-5" >
            <img src="/images/autism.jpeg" className="card-img-top mt-2" alt="..." style={{'height': '170px', 'alignSelf': 'center'}}/>
            <div className="card-body">
              <h5 className="card-title" style={{'color': 'white', 'paddingLeft': '40%'}}>Psycle</h5>
              <p className="card-text" style={{'color': 'white'}}>
                Platform for empowering children with Autism and their families.
              </p>
              
            </div>
          </div> */}
          
        </div>
      <button onClick={handleClose}>Close</button>
    </div>
  );
}

export default Projects;
